module.exports = __webpack_public_path__ + "static/media/architect-3.4c490298.svg";